'use client';

import { brand, secondary } from '@/app/styles/colors';
import { createTheme } from '@mantine/core';
export const theme = createTheme({
    primaryColor: "brand",
    colors: {
        brand,
        brandSecondary: secondary,
    },
    defaultRadius: "md",
    fontFamily:
        "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji",
    headings: {
        fontFamily:
            "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
    },
});
